(function () {
  "use strict";

  SeriesTrackCtrl.$inject = ['$scope'];
  angular
    .module('trainerWebApp.controllers')
    .controller('SeriesTrackCtrl', SeriesTrackCtrl);

  function SeriesTrackCtrl($scope) {
    //TBD
  }

})();
